import { forwardRef, useId } from 'react'

import { computeSize } from '../shared'
import type { IconProps } from '../shared'

/**
 * This icon has complex SVG content (clipPath, defs) that requires
 * a custom implementation instead of the createIcon factory.
 */
const CommentIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ size = 'small', className, color = 'currentColor', ...props }, ref) => {
    const computedSize = computeSize(size)
    const clipPathId = useId()

    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M9.38291 0.865859C11.6035 0.714834 13.8034 1.37712 15.5711 2.72947C17.3387 4.08181 18.5531 6.03181 18.9882 8.21449C19.4002 10.281 19.0851 12.4216 18.1052 14.2789L19.1388 18.1168C19.2166 18.406 19.1334 18.715 18.9207 18.9258C18.708 19.1364 18.3985 19.2162 18.1101 19.1357L14.3276 18.0802C12.4786 19.0702 10.3429 19.3985 8.27614 19.0014C6.09045 18.5814 4.13209 17.38 2.76751 15.6217C1.40306 13.8635 0.725178 11.6688 0.860776 9.4474C0.996383 7.226 1.93587 5.1298 3.50401 3.55059C5.07233 1.97135 7.16236 1.01689 9.38291 0.865859ZM14.5579 4.05352C13.1118 2.94726 11.3125 2.40492 9.49603 2.52846C7.67951 2.65201 5.97026 3.43303 4.68727 4.72491C3.40428 6.01684 2.63513 7.73176 2.52419 9.54913C2.4133 11.3664 2.96798 13.1621 4.08425 14.6004C5.20055 16.0387 6.80231 17.0213 8.59027 17.3649C10.3783 17.7085 12.2303 17.3894 13.8002 16.4673C13.9952 16.3527 14.2285 16.3226 14.4464 16.3834L17.1482 17.137L16.4093 14.3904C16.3517 14.1766 16.3815 13.9482 16.4923 13.7565C17.4036 12.1802 17.7101 10.3256 17.3541 8.54001C16.9981 6.7545 16.0039 5.15978 14.5579 4.05352Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

CommentIcon.displayName = 'CommentIcon'

export { CommentIcon }
